<template>
  <section id="fqa" class="faq-servicios">
    <!-- Header con logo y título -->
    <div class="faq-header">
      <img src="@/assets/logo_sin_fondo_recortado.png"  alt="Logo Empresa" class="faq-logo" />
      <h2 class="faq-titulo">🚨 Nuestros Servicios de Alarmas</h2>
    </div>

    <!-- Lista FAQ -->
    <div class="faq-lista">
      <div
        v-for="(item, index) in servicios"
        :key="index"
        class="faq-item"
        :class="{ abierto: item.abierto }"
        :style="{ animationDelay: (index * 0.2) + 's' }"
      >
        <div class="faq-pregunta" @click="toggle(index)">
          <span>{{ item.titulo }}</span>
          <svg
            class="faq-icono"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M19 9l-7 7-7-7" />
          </svg>
        </div>
        <transition name="desplegar">
          <div v-if="item.abierto" class="faq-respuesta">
            <p>{{ item.descripcion }}</p>
          </div>
        </transition>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "ServiciosAlarmasFAQ",
  data() {
    return {
      servicios: [
        {
          titulo: "🚨 Instalación de Alarmas Residenciales",
          descripcion:
            "Protege tu hogar con sistemas de alarma contra intrusiones, integrados con sensores de puertas y ventanas.",
          abierto: false,
        },
        {
          titulo: "🏢 Sistemas de Alarmas Empresariales",
          descripcion:
            "Implementamos alarmas para oficinas, comercios y naves industriales con monitoreo centralizado.",
          abierto: false,
        },
        {
          titulo: "📡 Sensores de Movimiento",
          descripcion:
            "Detección de movimientos sospechosos en interiores y exteriores para alertas inmediatas.",
          abierto: false,
        },
        {
          titulo: "🔔 Alarmas Contra Incendios",
          descripcion:
            "Detectores de humo y fuego que alertan de manera temprana para proteger vidas y bienes.",
          abierto: false,
        },
        {
          titulo: "🎥 Integración con Cámaras de Seguridad",
          descripcion:
            "Conexión de cámaras IP y DVR/NVR con tu sistema de alarmas para monitoreo completo.",
          abierto: false,
        },
        {
          titulo: "🌐 Acceso y Monitoreo Remoto",
          descripcion:
            "Supervisa tu sistema de alarmas desde tu celular o computadora en tiempo real.",
          abierto: false,
        },
        {
          titulo: "🔧 Mantenimiento Preventivo",
          descripcion:
            "Revisión periódica de sensores, alarmas y cámaras para garantizar su correcto funcionamiento.",
          abierto: false,
        },
        {
          titulo: "💾 Respaldo y Notificaciones",
          descripcion:
            "Recibe alertas automáticas y guarda registros de eventos en la nube o almacenamiento local.",
          abierto: false,
        },
        {
          titulo: "🛡️ Seguridad Avanzada",
          descripcion:
            "Integración de sistemas inteligentes, detección de intrusos, control de accesos y analítica avanzada.",
          abierto: false,
        }
      ],
    };
  },
  methods: {
    toggle(index) {
      this.servicios[index].abierto = !this.servicios[index].abierto;
    },
  },
};
</script>

<style scoped>
.faq-servicios {
  background: url('@/assets/Img/Banners/alarma.jpg') no-repeat center center;
  background-size: cover;
  padding: 3rem 2rem;
  position: relative;
  color: #fff;
}

.faq-servicios::before {
  content: "";
  position: absolute;
  top: 0; left: 0;
  width: 100%; height: 100%;
  background: rgba(0,0,0,0.7);
  z-index: 0;
}

.faq-servicios > * {
  position: relative;
  z-index: 1;
}

.faq-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.2rem;
  margin-bottom: 2rem;
  animation: fadeInDown 1s ease-in-out;
}

.faq-logo {
  width: 70px;
  height: auto;
  border-radius: 50%;
  box-shadow: 0 4px 12px rgba(255,0,0,0.6);
  animation: pulse 2s infinite;
}

.faq-titulo {
  font-size: 2.4rem;
  font-weight: bold;
  color: #ff0000;
  text-shadow: 0 2px 6px rgba(255,0,0,0.8);
  text-align: center;
}

.faq-lista {
  max-width: 850px;
  margin: 0 auto;
  text-align: left;
}

.faq-item {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 14px;
  margin-bottom: 1rem;
  overflow: hidden;
  transition: all 0.3s ease;
  border: 1px solid transparent;
  opacity: 0;
  transform: translateY(40px);
  animation: fadeInUp 0.8s forwards;
}

.faq-item.abierto {
  border: 1px solid #ff0000;
  box-shadow: 0 6px 20px rgba(255,0,0,0.4);
}

.faq-pregunta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.2rem;
  cursor: pointer;
  font-weight: bold;
  font-size: 1.2rem;
  transition: background 0.3s ease;
}

.faq-pregunta:hover {
  background: rgba(255,0,0,0.1);
}

.faq-icono {
  width: 26px;
  height: 26px;
  transition: transform 0.4s ease;
}

.faq-item.abierto .faq-icono {
  transform: rotate(180deg) scale(1.2);
  color: #ff0000;
}

.faq-respuesta {
  padding: 1rem 1.2rem;
  font-size: 1rem;
  line-height: 1.6;
  color: #ddd;
  animation: fadeIn 0.4s ease;
}

@keyframes fadeInUp {
  from { opacity: 0; transform: translateY(40px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes fadeInDown {
  from { opacity: 0; transform: translateY(-40px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(-10px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes pulse {
  0% { transform: scale(1); box-shadow: 0 0 10px rgba(255,0,0,0.6); }
  50% { transform: scale(1.05); box-shadow: 0 0 20px rgba(255,0,0,0.9); }
  100% { transform: scale(1); box-shadow: 0 0 10px rgba(255,0,0,0.6); }
}

/* Transición desplegable */
.desplegar-enter-active,
.desplegar-leave-active {
  transition: max-height 0.5s ease, opacity 0.5s ease;
}
.desplegar-enter,
.desplegar-leave-to {
  max-height: 0;
  opacity: 0;
}
</style>
